"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.flattenPairToList = void 0;
/**
 * If the argument is a list, return a List object, backed by an array of the list elements.
 * Otherwise, return an ImproperList object containing the proper part and the last pair.
 */
function flattenPairToList(pair) {
    const seen = new Set();
    const flattened = [];
    while (true) {
        const tail = pair.tail;
        if (tail.type === 'empty list') {
            flattened.push({ value: pair.head, pair });
            return { type: 'List', value: flattened };
        }
        else if (tail.type === 'pair') {
            seen.add(pair);
            if (seen.has(tail)) {
                return {
                    type: 'ImproperList',
                    value: { properPart: flattened, lastPair: pair }
                };
            }
            flattened.push({ value: pair.head, pair });
            pair = tail;
        }
        else {
            return { type: 'ImproperList', value: { properPart: flattened, lastPair: pair } };
        }
    }
}
exports.flattenPairToList = flattenPairToList;
//# sourceMappingURL=listHelpers.js.map